module.exports = __webpack_public_path__ + "h5/img/share1.610b08a5.png";